import { render, staticRenderFns } from "./newsDetailPC.vue?vue&type=template&id=259be965&scoped=true"
import script from "./newsDetailPC.vue?vue&type=script&lang=js"
export * from "./newsDetailPC.vue?vue&type=script&lang=js"
import style0 from "./newsDetailPC.vue?vue&type=style&index=0&id=259be965&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259be965",
  null
  
)

export default component.exports